// extracted by mini-css-extract-plugin
export var dataCell = "_pe-2";
export var dataRow = "_pe-0";
export var headerRow = "_pe-1";